import { lazyPage } from "@/router/lazyPage";

export const ProjectBudgets = lazyPage(
  () => import("@/pages/Project/sections/ProjectBudgets/ProjectBudgets"),
  "ProjectBudgets",
);
export const ProjectClientBudgets = lazyPage(
  () => import("@/pages/Project/sections/ProjectClientBudgets/ProjectClientBudgets"),
  "ProjectClientBudgets",
);
export const ProjectCosts = lazyPage(
  () => import("@/pages/Project/sections/Costs/ProjectCosts"),
  "ProjectCosts",
);
export const ProjectDiaryEntries = lazyPage(
  () => import("@/pages/Project/sections/ProjectDiaryEntries/ProjectDiaryEntries"),
  "ProjectDiaryEntries",
);
export const ProjectDiaryEntryDetailPage = lazyPage(
  () =>
    import("@/pages/Project/sections/ProjectDiaryEntries/components/ProjectDiaryEntryDetailPage"),
  "ProjectDiaryEntryDetailPage",
);
export const ProjectDiaryEntryFormPage = lazyPage(
  () => import("@/pages/Project/sections/ProjectDiaryEntries/components/ProjectDiaryEntryFormPage"),
  "ProjectDiaryEntryFormPage",
);
export const ProjectDocuments = lazyPage(
  () => import("@/pages/Project/sections/Documents/ProjectDocuments"),
  "ProjectDocuments",
);
export const ProjectEquipments = lazyPage(
  () => import("@/pages/Project/sections/Equipments/ProjectEquipments"),
  "ProjectEquipments",
);
export const ProjectIndexRedirect = lazyPage(
  () => import("@/pages/Project/ProjectIndexRedirect"),
  "ProjectIndexRedirect",
);
export const ProjectMaterials = lazyPage(
  () => import("@/pages/Project/sections/Materials/ProjectMaterials"),
  "ProjectMaterials",
);
export const ProjectOccurrences = lazyPage(
  () => import("@/pages/Project/sections/Occurrences/ProjectOccurrences"),
  "ProjectOccurrences",
);
export const ProjectOverview = lazyPage(
  () => import("@/pages/Project/ProjectOverview"),
  "ProjectOverview",
);
export const ProjectPhotos = lazyPage(
  () => import("@/pages/Project/sections/Photos/ProjectPhotos"),
  "ProjectPhotos",
);
export const ProjectPurchaseRequests = lazyPage(
  () => import("@/pages/Project/sections/Purchasing/ProjectPurchaseRequests"),
  "ProjectPurchaseRequests",
);
export const PurchaseRequestDetailPage = lazyPage(
  () => import("@/pages/Project/sections/Purchasing/PurchaseRequestDetailPage"),
  "PurchaseRequestDetailPage",
);
export const ProjectQuotations = lazyPage(
  () => import("@/pages/Project/sections/Purchasing/ProjectQuotations"),
  "ProjectQuotations",
);
export const QuotationDetailPage = lazyPage(
  () => import("@/pages/Project/sections/Purchasing/QuotationDetailPage"),
  "QuotationDetailPage",
);
export const ProjectPurchaseOrders = lazyPage(
  () => import("@/pages/Project/sections/Purchasing/ProjectPurchaseOrders"),
  "ProjectPurchaseOrders",
);
export const PurchaseOrderDetailPage = lazyPage(
  () => import("@/pages/Project/sections/Purchasing/PurchaseOrderDetailPage"),
  "PurchaseOrderDetailPage",
);
export const ProjectReports = lazyPage(
  () => import("@/pages/Project/sections/Reports/ProjectReports"),
  "ProjectReports",
);
export const ProjectServiceFront = lazyPage(
  () => import("@/pages/Project/sections/ProjectServiceFront/ProjectServiceFront"),
  "ProjectServiceFront",
);
export const ProjectShell = lazyPage(() => import("@/pages/Project/ProjectShell"), "ProjectShell");
export const ProjectTracking = lazyPage(
  () => import("@/pages/Project/sections/Tracking/ProjectTracking"),
  "ProjectTracking",
);
export const Projects = lazyPage(() => import("@/pages/Project/Projects"), "Projects");
